import React from "react";
import { useTranslate } from "react-admin";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";

import { UnassignedDeliveryContent } from "../api/unassigned_delivery_contents";
import { Grade } from "../api/common";

const commonStyles = {
  table: {
    maxWidth: "100%",
    width: { xs: "100%", sm: 400 },
  },
  caption: {
    color: grey.A700,
  },
};

export const UnassignedDeliveryContentTable = (props: {
  unassignedDeliveryContents: UnassignedDeliveryContent[];
  inspectionResultGrades: (Grade | null)[];
}) => {
  const translate = useTranslate();
  const { inspectionResultGrades, unassignedDeliveryContents } = props;

  const gradeNames: Array<{ id: null | number; name: string }> = inspectionResultGrades
    .flatMap((grade) => (grade === null ? [] : grade))
    .map((grade) => {
      return {
        id: grade.id,
        name: grade.name,
      };
    });
  gradeNames.push({
    id: null,
    name: translate("ui.value.default_grade"),
  });

  if (unassignedDeliveryContents.length === 0) {
    return (
      <Box>
        <Typography variant="caption" sx={commonStyles.caption}>
          {translate("ui.individual_deliveries.unassigned_delivery_content")}
        </Typography>
        <Box my={2}>
          <Typography>{translate("ui.individual_deliveries.no_unassigned_delivery_content")}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="caption" sx={commonStyles.caption}>
        {translate("ui.individual_deliveries.unassigned_delivery_content")}
      </Typography>
      <Box my={2}>
        <TableContainer sx={commonStyles.table}>
          <Table size="small" sx={{ tableLayout: "fixed", width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell>{translate("resources.amends.fields.grade")}</TableCell>
                <TableCell>{translate("resources.amends.fields.package_count")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {unassignedDeliveryContents.map((udc) => {
                const { grade_id, package_count } = udc;
                const gradeName = gradeNames.find((gn) => gn.id === grade_id)?.name;
                return (
                  <TableRow key={gradeName}>
                    <TableCell component="th" scope="row">
                      {gradeName}
                    </TableCell>
                    <TableCell>{package_count}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};
